module.exports = __webpack_public_path__ + "img/user_edit_icon.06ae8730.svg";